import { Button, Form, Row, Col, Spinner } from "reactstrap";

import { ChangeEvent, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { UserProps, UserToken } from "../../context/hooks/useAuth";
import InputPassword from "../../components/Inputs/InputPassword";
import InputEmailLogin from "../../components/Inputs/InputEmailLogin";
import "./ResetPassword.css";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import { UserTypeContext } from "../../context/UserTypeContext";
import { jwtDecode } from "jwt-decode";
import KeyIcon from "@mui/icons-material/Key";
import { useToast } from "../../context/ToastContext";
import { set } from "lodash";
import api from "../../api";

const ResetPassword = () => {
  const { handleLogin, resetPassword, decryptTokenPass } =
    useContext(AuthContext);
  const { getUsersById } = useContext(UserTypeContext);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 650);
  const [userId, setUserId] = useState("");
  const showToast = useToast();
  const [resertPassoword, setResertPassoword] = useState<any>({
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);

  const handleLoginClick = async () => {
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%?&#_\-+=:;,.\/\\|~^()\[\]{}'"<>])[A-Za-z\d@$!%?&#_\-+=:;,.\/\\|~^()\[\]{}'"<>]{8,}$/;

    if (resertPassoword.password !== resertPassoword.confirmPassword) {
      showToast("info", "As senhas não coincidem!");
      return;
    }

    if (!strongPasswordRegex.test(resertPassoword.password)) {
      showToast(
        "info",
        "A senha deve ter pelo menos 8 caracteres, incluindo letras maiúsculas, minúsculas e um símbolo como #%!"
      );
      return;
    }

    setLoading(true);
    await resetPassword(userId, resertPassoword.password);
    setLoading(false);
  };

  const handleInputChange = (valueAtt: any, name: string) => {
    setResertPassoword((prevLogin: any) => ({
      ...prevLogin,
      [name]: valueAtt,
    }));
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      handleLoginClick();
    }
  };
  useEffect(() => {
    const url = window.location.href;
    const urlObj = new URL(url);
    let token = urlObj.searchParams.get("token");
    token = decodeURIComponent(token || "").replace(/ /g, "+");
    const obj = (jwtDecode(token) as any);
    setUserId(obj.UserId);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 650);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div style={{ position: "absolute", top: "30px", right: "10px" }}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "/auth/login";
          }}
          className="button-create-user"
          type="button"
          disabled={loading}
        >
          <Person2OutlinedIcon style={{ color: "#33BBED" }} />
          Login
        </Button>
      </div>
      <Row className="justify-content-center">
        <Col
          lg="10"
          md="7"
          className="d-flex"
          style={{
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
          }}
        >
          <img
            className="login-logo"
            alt="Cvortex"
            src={require("../../assets/img/brand/Simbolo_Negativa_sf.png")}
          />

          <div className="d-flex" style={{ flexDirection: "column" }}>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "5.76px",
                color: "#002231",
                opacity: 1,
                fontSize: "24px",
              }}
            >
              Crie sua nova senha!{" "}
            </span>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "2.24px",
                color: "#002231",
                opacity: 0.5,
                fontSize: "11px",
              }}
            >
              Digite uma nova senha e confirme no campo abaixo. Após isso, sua
              senha será redefinida.
            </span>
          </div>

          <div className="px-lg-5" style={{ width: "84%" }}>
            <Form
              role="form"
              style={{
                gap: "27px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <InputPassword
                name="password"
                value={resertPassoword.password}
                handleChange={handleInputChange}
                label={"Senha"}
                onKeyDown={handleKeyDown}
              />
              <InputPassword
                name="confirmPassword"
                value={resertPassoword.confirmPassword}
                handleChange={handleInputChange}
                label={"Confirmar Senha"}
                onKeyDown={handleKeyDown}
              />
            </Form>
            <div className="text-center d-flex justify-content-center">
              <Button
                onClick={handleLoginClick}
                className="my-4 button-login"
                type="button"
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm">Loading...</Spinner>
                ) : (
                  <KeyIcon />
                )}{" "}
                Redefinir Senha
              </Button>
            </div>
          </div>

          <div
            style={{
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/auth/register";
            }}
          >
            <span
              style={{
                textAlign: "center",
                color: "#000",
                fontSize: "13px",
              }}
            >
              Ainda não tem conta?{" "}
            </span>
            <span
              style={{
                textAlign: "center",
                color: "#33BBED",
                fontSize: "13px",
              }}
            >
              Crie uma gratuitamente!
            </span>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ResetPassword;
